const Radiobox = ({ name, options, onChange, checked, className = '' }) => {
    return (
        <fieldset id={name} className={`radio-group ${className}`}>
            {options.map((option) => (
                <div key={option.id} className="item-radioBox">
                    <input
                        type="radio"
                        name={name}
                        id={option.id}
                        value={option.value}
                        onChange={onChange}
                        defaultChecked={option.defaultChecked}
                        checked={checked[name]?.includes(option.value) || false}
                    />
                    <span />
                    <label htmlFor={option.id}>
                        <span>{option.label}</span>
                    </label>
                </div>
            ))}
        </fieldset>
    );
};
export default Radiobox;
